import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AuthElementsModule,
  I18nModule,
  LoaderViewModule,
  LoadingIconModule,
  PanelModalModule,
  SharedAngularComponentsAvlaModule,
  SmartadminDatatableModule,
  SmartadminInputModule,
  SmartadminModule,
  SmartadminValidationModule,
  SmartadminWizardsModule,
} from 'shared-angular-components-avla';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RetryNotificationMessageService } from 'base-angular-avla';
import { GenericTableAvlaModule } from 'generic_table_avla_front_components';
import { IonicModule } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { DynamicFormParentModule } from 'dynamicform-front-components';
import {
  FormInputCheckboxModule,
  FormInputSelectModule,
  FormInputTextModule,
  LinkShowMoreModule,
  PanelAddRowModule,
  PanelWidgetModule,
} from 'amaru-web-components';
import { Select2Module } from 'ng-select2-component';
import { ModalModule } from 'ngx-bootstrap/modal';

import { SinisterService } from 'app/service/sinister.service';

import { MlModalComponent } from './components/ml-modal/ml-modal.component';
import { MlTableSinesterComponent } from './components/ml-table-sinester/ml-table-sinester.component';
import { MlTableStateComponent } from './components/ml-table-state/ml-table-state.component';
import { MlGenerateExcelComponent } from './components/ml-generate-excel/ml-generate-excel/ml-generate-excel.component';
import { MlFormDinamicComponent } from './components/ml-modal/ml-form-dinamic/ml-form-dinamic.component';
import { MlStatusPersonComponent } from './components/ml-status-person/ml-status-person.component';
import { MlCreateStatusPersonComponent } from './components/ml-create-status-person/ml-create-status-person.component';
import { MlUnlockTemporarilyComponent } from './components/ml-unlock-temporarily/ml-unlock-temporarily.component';
import { MessageWithLinkComponent } from './components/message-notification';

import { ValidatorPerson } from './service/Validators/validator-person.service';
import { InfoClienteService } from './service/BehaviorSubject/infoClient.service';
import { routing } from './consulta-mark-list.routing';
import { ConsultaMarkListComponent } from './consulta-mark-list.component';

@NgModule({
  imports: [
    CommonModule,
    SmartadminModule,
    SmartadminWizardsModule,
    SmartadminDatatableModule,
    SmartadminValidationModule,
    DynamicFormParentModule,
    SmartadminInputModule,
    LoadingIconModule,
    PanelModalModule,
    IonicModule,
    AuthElementsModule,
    ReactiveFormsModule,
    GenericTableAvlaModule,
    SharedAngularComponentsAvlaModule.forRoot(),
    Select2Module,
    routing,
    FormsModule,
    PanelAddRowModule,
    FormInputSelectModule,
    LoaderViewModule,
    I18nModule,
    LinkShowMoreModule,
    PanelWidgetModule,
    FormInputTextModule,
    ModalModule,
    FormInputCheckboxModule,
  ],
  declarations: [
    ConsultaMarkListComponent,
    MlTableSinesterComponent,
    MlFormDinamicComponent,
    MlModalComponent,
    MlTableStateComponent,
    MlGenerateExcelComponent,
    MlStatusPersonComponent,
    MlCreateStatusPersonComponent,
    MlUnlockTemporarilyComponent,
  ],
  exports: [ConsultaMarkListComponent],
  providers: [
    RetryNotificationMessageService,
    ValidatorPerson,
    InfoClienteService,
    StatusBar,
    SinisterService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConsultaMarkListModule {}
